import {createStore, combineReducers, applyMiddleware} from 'redux';
import authReducer from "./redux/reducers/login.reducer";
import {thunk} from "redux-thunk";
import folderReducer from "./redux/reducers/folders.reducer";
import globalReducer from "./redux/reducers/global.reducer";
import driveFilesReducer from "./redux/reducers/driveFiles.reducer";
import searchReducer from "./redux/reducers/search.reducer";
import channelReducer from "./redux/reducers/channel.reducer";

const rootReducer = combineReducers({
    auth: authReducer,
    folders: folderReducer,
    globalState: globalReducer,
    driveFiles: driveFilesReducer,
    search: searchReducer,
    channel: channelReducer,
});

// Create the Redux store
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;